import React from 'react'
import { Row, Col } from 'antd'

import InventoryTags from 'containers/inventory/shared/tags'
import InventoryResourceContainer from '../../container'
import Events from 'containers/inventory/shared/events'

import { INVENTORY_SERVICES } from 'lib/resources/constants'
import { S3_BUCKET_OBJECTS } from '../../metrics-tabs/services/s3'
import Section from 'components/layout/content/section'
import Tabs from 'components/antd/tabs'

const Config = ({ item }) => {
  return (<>
    {item?.tags?.length !== 0 && <InventoryTags tags={item.tags} inverse />}
  </>)
}

const S3 = ({ item }) => {
  return (
    <>
      <InventoryResourceContainer item={item} service={INVENTORY_SERVICES.S3.id} initialChart={S3_BUCKET_OBJECTS}>
        <Row gutter={12}>
          <Col xs={24} md={16}>
            <Section>
              <Tabs defaultActiveKey="configuration" items={[{ key: 'configuration', label: 'Configuration', children: <Config item={item} /> }]} />
            </Section>
          </Col>
          <Col xs={24} md={8}>
            <Events resourceId={item.id} />
          </Col>
        </Row>
      </InventoryResourceContainer>
    </>
  )
}

export default S3
